
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1px7g_jp1qa_145",
  "chart-filter": "awsui_chart-filter_1px7g_jp1qa_177",
  "custom-icon-wrapper": "awsui_custom-icon-wrapper_1px7g_jp1qa_181"
};
  